/**
 * Returns a display label and color for a given filename based on extension.
 */
export function getFileIcon(name) {
  const ext = (name.split(".").pop() || "").toLowerCase();
  if (ext === "pdf") return { label: "PDF", color: "#E63946" };
  if (ext === "doc" || ext === "docx")
    return { label: "DOC", color: "#2B6CB0" };
  if (
    ext === "jpg" ||
    ext === "jpeg" ||
    ext === "png" ||
    ext === "gif" ||
    ext === "webp"
  )
    return { label: "IMG", color: "#6B46C1" };
  if (ext === "xls" || ext === "xlsx" || ext === "csv")
    return { label: "XLS", color: "#276749" };
  return { label: "FILE", color: "#718096" };
}

export function formatSize(bytes) {
  if (!bytes) return "—";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
}

export function hexToRgba(hex, opacity) {
  const clean = hex.replace("#", "");
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function groupByContract(assignments) {
  return assignments.reduce((acc, file) => {
    const key = file.contract?.number ?? "__none";
    if (!acc[key]) {
      acc[key] = { contract: file.contract, files: [] };
    }
    acc[key].files.push(file);
    return acc;
  }, {});
}

export const TYPE_BADGES = {
  "file-upload": { badge: "Multi-contract", badgeColor: "#2B6CB0" },
  compliance: { badge: "Required", badgeColor: "#C05621" },
};

export const ERROR_MESSAGES = {
  size: "Exceeds 50MB size limit",
  type: "Invalid file type — only PDF, Word, and Excel files are accepted",
  totalSize: "Total size exceeds 50MB limit",
};

export const VALID_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "csv",
  "png",
];
export const FILE_SIZE_LIMIT = 50 * 1024 * 1024; // 50 MB
export const TOTAL_SIZE_LIMIT = 50 * 1024 * 1024; // 50 MB cumulative

export function getTotalSize(files) {
  return files.reduce((sum, f) => sum + (f.size || 0), 0);
}
